import * as React from "react";
import { ensureLoaded, getSnapshot, play, setMuted, startAudio, subscribe } from "./engine";

export function useSound(): {
  play: typeof play;
  isMuted: boolean;
  toggleMute: () => void;
  hasAnySound: boolean;
  /** Audio has been unlocked by a gesture (sound is actually playing). */
  started: boolean;
  /** Unlock + start audio (the toggle calls this on the first interaction). */
  startAudio: () => void;
} {
  React.useEffect(() => {
    void ensureLoaded();
  }, []);

  const snap = React.useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  const toggleMute = React.useCallback(() => setMuted(!getSnapshot().isMuted), []);

  return {
    play,
    isMuted: snap.isMuted,
    toggleMute,
    hasAnySound: snap.hasAnySound,
    started: snap.started,
    startAudio,
  };
}
